import React from 'react';
import { Box } from 'ink';
import { Spinner } from './lib/components/Spinner';

export const LoadingIndicator: React.FC = () => {
  return (
    <Box>
      <Spinner text="GitLab Duo is thinking..." changeColors />
    </Box>
  );
};
